import { DateTime } from "luxon";

const stringOrDateTime = (date: DateTime | string) => {
	if (typeof date === "string") {
		return DateTime.fromISO(date);
	}
	return date;
};

export const formatLongDatetime = (date: DateTime | string) =>
	stringOrDateTime(date).setLocale("fr-FR").toFormat("ff");
